import React from 'react'
import { Nav, Stack } from 'react-bootstrap'
import { NavLink, useLocation } from 'react-router-dom'

const AccountNavigation = ({ t, formatted_joining_date, formatted_last_working_date, data }) => {

    const location = useLocation();
    const currentURL = location.pathname;

    const profileTabs = [
        {
            path: '/my-profile',
            matchPaths: ['/my-profile', '/edit-profile'],
            label: t('page.tab_general_details'),
        },
        {
            path: '/my-profile/change-password',
            matchPaths: ['/my-profile/change-password'],
            label: t('page.edit_change_password'),
        },
    ];

    if (data?.user_type === 2) {
        profileTabs.push({
            path: '/my-profile/address-details',
            matchPaths: ['/my-profile/address-details'],
            label: t('page.edit_address_details'),
        },
            {
                path: '/my-profile/contact-additional-info',
                matchPaths: ['/my-profile/contact-additional-info'],
                label: t('page.edit_contact_additional_info'),
            },
            {
                path: '/my-profile/department-designation',
                matchPaths: ['/my-profile/department-designation'],
                label: t('page.edit_department_designation'),
            },
            {
                path: '/my-profile/skills',
                matchPaths: ['/my-profile/skills'],
                label: t('page.edit_my_profile_skills'),
            },
            {
                path: '/my-profile/other',
                matchPaths: ['/my-profile/other'],
                label: t('page.edit_other'),
            }
        )
    } else {
        profileTabs.push(
            {
                path: '/my-profile/contact-additional-info',
                matchPaths: ['/my-profile/contact-additional-info'],
                label: t('page.edit_contact_additional_info'),
            }
        )
    }

    return (
        <div>
            <Stack className="page-title flex-row justify-content-between align-items-center flex-wrap">
                <h1 className="title">{t('page.header_myProfile')}</h1>
                <div className="d-flex align-items-center gap-2">
                    {data?.user_type == 2 && formatted_joining_date != '' && formatted_joining_date != null ? <span className="status-label blue bordered">{t('page.header_join_title')} - {formatted_joining_date ?? ''}</span> : ''}
                    {
                        data?.user_type == 2 && formatted_last_working_date != '' && formatted_last_working_date != null ? <span className="status-label red bordered mt-0 mt-sm-3 mt-md-0">
                            {t('page.header_left_title')} - {formatted_last_working_date}
                        </span> : ''
                    }
                </div>
            </Stack>
            <div className="alert-bar mx-4">
                If there is any change/update in this information then email to&nbsp;
                <a href="mailto:hr@technource.com" className="mail-id">
                    hr@technource.com
                </a>
                &nbsp;with correct/updated info.
            </div>
            <Nav className="custom-tabs mt-4">
                {profileTabs.map((tab) => {
                    const isActive = tab.matchPaths.some((matchPath) => {
                        // Special rule for General Details
                        if (matchPath === '/my-profile') {
                            return currentURL === '/my-profile';
                        }

                        // Normal rule for others
                        return currentURL === matchPath || currentURL.startsWith(matchPath + '/');
                    });

                    return (
                        <Nav.Item key={tab.path}>
                            <NavLink
                                to={tab.path}
                                className={`nav-link ${isActive ? 'active active-tab' : ''}`}
                            >
                                {tab.label}
                            </NavLink>
                        </Nav.Item>
                    );
                })}
            </Nav>
        </div>
    )
}

export default AccountNavigation
